<template>
  <div class="sandMsgCon instantMsgTemplate kakao">
    <div class="msgBox">
      <div class="msgTemplate">
        <div class="kakakoTemplate popupKaKaoTemplate">
          <div class="head">
            通知トーク到着
          </div>
          <div class="template_body scroll-y">
            <instant-message-template
              ref="instantMessageTemplate"
              :plusFriendId="kakaoInstantMessagePlusFriendId"
              :originalTemplate="selectedBrandTemplate"
              :templateVariables="kakaoVariables"
              :instantMessageType="instantMessageType"
            ></instant-message-template>
          </div>
        </div>
      </div>
      <div class="msgTypeBox">
        <table>
          <colgroup>
            <col style="width:22%" />
            <col style="width:78%" />
          </colgroup>
          <tbody>
          <tr>
          <tr>
            <th>テンプレート</th>
            <td>
              <v-select
                v-model="selectedBrandTemplateId"
                label="テンプレートを選択してください。"
                :items="brandTemplates"
                item-text="templateName"
                item-value="templateId"
                class="UXselect"
                color="#ff8c8c"
                hide-details
                outline
                solo
                no-data-text="データがありません。"
              ></v-select>
            </td>
          </tr>
          <tr>
            <th>受信番号</th>
            <td>
              <v-text-field
                v-model="destinationPhoneNumber"
                placeholder="受信番号を入力してください。"
                type="number"
                class="UXinput UXicon-edit"
                hide-details
                outline
                solo
              ></v-text-field>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <v-checkbox
                v-model="sendTypeReplaceIfFail"
                id="manual_send_replace_check"
                label="送信失敗時 SMS/LMS 転換送信"
                class="UXcheckbox nudgeLeft"
                hide-details
              >
              </v-checkbox>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="btn">
          <div class="msgCount" v-if="$targetMake.isSeller && !msgCountData.isUnlimitedMessageCountBrand">※ 無料カカオ通知トーク残りの件数 ( <span class="colorBlue">{{ msgCountData.monthFreeSendCount }}</span> 件)</div>
          <v-btn round dark large color="#ff8c8c" class="UXbtn" @click="kakaoInstantMessageSubmit">送信</v-btn>
          <tooltip
            text="· 通知トークはテンプレートを登録すると利用可能となり, カカオの<br /> &nbsp;&nbsp;事前承認が必要です。<br />· 通知トークで送信できるメッセージは最大1000文字です。"
            classes="UXicon-info_outlined"
            icon-color="#DCDCDC"
            :is-icon="true"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.min.css'
import instantMessageTemplate from '../../message/fragments/instant_message_template'
import sendMessageHistory from '../../message/fragments/send_message_history'
import InstantTemplateMessageType from '../../message/enum/instant_template_message_type'
import helper from 'util/helpers'
import Tooltip from '@/components/tooltip'

import KakaoInstantMessageUtil from '../util/kakaoInstantMessageUtil'

export default {
  name: 'ticket_incident_message',
  props: {
    setKakaoInstantMessageAvailable: {
      type: Function
    },
    ticketId: {
      type: Number
    },
    customerNumber: {
      type: String
    },
    msgCountData: {
      type: Object
    }
  },
  data () {
    return {
      brands: [],
      brandId: '',
      brandName: '',
      kakaoInstantMessagePlusFriendId: '',
      brandTemplates: [],
      selectedBrandTemplateId: 0,
      selectedBrandTemplate: null,
      sendTypeReplaceIfFail: false,
      fileInputText: '',
      fileInputPlaceHolder: 'ファイル送信モードです。 番号の直接入力は制限されます。',
      senderPhoneNumber: '',
      destinationPhoneNumber: '',
      excelFormData: null,
      manualSendDisable: false,
      fileSendDisable: true,
      loadingDialog: false,
      kakaoVariables: [],
      instantMessageType: InstantTemplateMessageType.TICKET,
      sendingKakao: false
    }
  },
  computed: {
    ...mapGetters([
      'currentBrandId',
      'currentBrandName'
    ])
  },
  components: {
    instantMessageTemplate,
    sendMessageHistory,
    VueCtkDateTimePicker,
    Tooltip
  },
  mounted () {
    this.initialize()
  },
  watch: {
    selectedBrandTemplateId (newId) {
      this.selectedBrandTemplate = this.brandTemplates.find(brandTemplate => brandTemplate.templateId === newId)
    },
    selectedBrandTemplate (newTemplate) {
      if (helper.isStringValid(newTemplate.templateContent)) {
        this.makeKakaoVariableForm()
      }
    },
    customerNumber () {
      if (this.customerNumber !== '-') {
        this.destinationPhoneNumber = this.customerNumber
      }
    }
  },
  methods: {
    // ----------------------------------------------------------------------
    // 화면 초기화 (브랜드 채널 데이터, 템플릿 목록 등 로드)
    initialize () {
      this.destinationPhoneNumber = ''
      this.axios.get('/api/agent/fetchBrands').then(result => {
        if (result.data.code !== 0) throw result.data.message
        const data = result.data.data
        this.brands = []
        data.forEach(brand => {
          this.brands.push({id: brand.id, name: brand.name})
        })
        if (this.currentBrandId) {
          this.brandId = this.currentBrandId
          this.brandName = this.currentBrandName
        } else {
          this.brandId = data[0].id
          this.brandName = data[0].name
        }
      }, () => this.$alertMsg(this.$const.SYS_ERR))
        .then(() => this.checkAvailability())
        .catch(errorMsg => this.$alertMsg(errorMsg))
    },
    checkAvailability () {
      this.axios.get('/api/brand/isUsableModuleChannel', {
        params: {
          brandId: this.brandId,
          moduleName: 'MESSAGE',
          channelName: 'KAKAO_INSTANT_MESSAGE'
        }
      }).then(result => {
        if (result.data.code === 0) {
          this.searchKakaoInstantMessageInfo()
          this.searchKakaoInstantTempates()
        }
      })
    },
    // ----------------------------------------------------------------------
    // 알림톡 템플릿 파싱
    makeKakaoVariableForm () {
      const checkNameTag = this.selectedBrandTemplate.templateContent.match(/<%([^<%>]*)%>/g)
      const result = checkNameTag === null ? [] : checkNameTag.map(nameTag => {
        return {name: nameTag.replace(/[<%>]+/g, '').trim(), value: ''}
      })
      this.kakaoVariables = this.removeDuplicate(result)
    },
    removeDuplicate (arr) {
      const result = []
      if (arr) {
        arr.forEach(variableObject => {
          if (result.findIndex(found => found.name === variableObject.name) < 0) {
            result.push(variableObject)
          }
        })
      }
      return result
    },
    searchKakaoInstantMessageInfo () {
      this.axios.get('/api/brand/searchChannelData', {
        params: {
          brandId: this.brandId,
          moduleName: 'MESSAGE',
          channelName: 'KAKAO_INSTANT_MESSAGE'
        }
      }).then(result => {
        if (result.data.code === -9004) {
        } else if (result.data.code === 0) {
          if (result.data.data && result.data.data.kakaoInstantMessagePlusFriendId && result.data.data.kakaoInstantMessageNumber) {
            this.setKakaoInstantMessageAvailable()
            this.senderPhoneNumber = result.data.data.kakaoInstantMessageNumber
            this.kakaoInstantMessagePlusFriendId = result.data.data.kakaoInstantMessagePlusFriendId
          }
        } else {
          throw result.data.message
        }
      }, () => this.$alertMsg(this.$const.SYS_ERR))
        .catch(errorMsg => this.$alertMsg(errorMsg))
    },
    searchKakaoInstantTempates () {
      this.axios.get('/gateway/message/template/kakao-instant-message', {
        params: {
          brandId: this.brandId
        }
      }).then(result => {
        if (result.data.code !== 0) throw result.data.message
        this.brandTemplates = result.data.data
        if (this.brandTemplates.length > 0) {
          this.selectedBrandTemplateId = this.brandTemplates[0].templateId
        }
      }, () => this.$alertMsg(this.$const.SYS_ERR))
        .catch(errorMsg => this.$alertMsg(errorMsg))
    },
    checkVariableFull () {
      return this.kakaoVariables.map(variable => helper.isStringValid(variable.value)).reduce((left, right) => left && right, true)
    },
    parseFullMessage () {
      let sendMessage = `${this.selectedBrandTemplate.templateContent}`
      this.kakaoVariables.forEach(obj => {
        const regExp = new RegExp(`<%${obj.name}%>`, 'g')
        if (KakaoInstantMessageUtil.isNameConsultUrl(obj.name)) {
          let link = this.$refs.instantMessageTemplate.getRealLink()
          sendMessage = sendMessage.replace(regExp, link)
        } else {
          sendMessage = sendMessage.replace(regExp, obj.value)
        }
      })
      return sendMessage
    },
    // ----------------------------------------------------------------------
    // 알림톡 유효성 검사 및 발송
    kakaoInstantMessageSubmit () {
      if (!this.ticketId) {
        this.$alertMsg('正常ではない経路です。')
        return
      }
      if (this.kakaoInstantMessagePlusFriendId === '') {
        this.$alertMsg('通知トークチャネルID登録後に使用できます。 管理者にお問い合わせください。')
        return false
      }

      // 바로 전송하는 쿼리..
      if (!this.checkVariableFull()) {
        this.$alertMsg('入力必須項目の中に空欄があります。 確認後、再送信依頼をしてください。')
        return false
      }

      const regex = /(\u00a9|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g
      const emojiArr = this.kakaoVariables.filter(obj => {
        if (obj.value.replace(regex, '').length !== obj.value.length) {
          return true
        }
      })
      if (emojiArr.length > 0) {
        this.$alertMsg('企業型テキストメッセージとカカオ通知トークは<br />通信会社の方針に従って<br />Emoji(😀)をサポートしません。')
        return false
      }

      if (!/^\d{3}\d{3,4}\d{4}$/g.test(this.destinationPhoneNumber.replace(/-/g, ''))) {
        this.$alertMsg('電話番号の形式が正しくありません。')
        return false
      }
      // TODO 실제 발송.
      this.singlePhoneNumberSend()
    },
    // 실제 ticket쪽 api 콜
    singlePhoneNumberSend () {
      if (this.sendingKakao) return

      this.sendingKakao = true
      const message = this.parseFullMessage()

      let param = new FormData()
      param.set('brandId', this.brandId)
      param.set('ticketId', this.ticketId)
      param.set('channelName', 'KAKAO_INSTANT_MESSAGE')
      param.set('content', message)
      param.set('serviceTelNumber', this.senderPhoneNumber.replace(/-/g, ''))
      param.set('phoneNumbers', this.destinationPhoneNumber.replace(/-/g, ''))
      param.set('messageTemplateId', this.selectedBrandTemplate.templateId)
      param.set('isSendSmsOnFailure', this.sendTypeReplaceIfFail)
      param.set('sendSmsOnFailureTelNumber', this.senderPhoneNumber.replace(/-/g, ''))

      this.$http({
        method: 'POST',
        url: '/api/apps/message/send',
        timeout: 120000,
        data: param
      }).then((result) => {
        const { code, message, data } = result.data
        if (code === -20027) {
          this.$toasted.error(message)
          return
        } else if (code === -20034) {
          this.$alertMsg(message)
        } else if (result.data.code !== 0) throw message
        if (result.data.code === 0) {
          this.$alertMsg('通知トークの送信が完了しました。')
          this.initialize()
          this.clearVariables()
          if (this.$targetMake.isSeller && !data.isUnlimitedMessageCountBrand) {
            this.$emit('sendMsgAndUpdateCount', {
              type: 'KAKAO',
              count: {
                isUnlimitedMessageCountBrand: data.isUnlimitedMessageCountBrand,
                monthFreeSendCount: data.monthFreeSendCount
              }})
          }
        }
      }, () => this.$alertMsg(this.$const.SYS_ERR))
        .catch(errorMsg => this.$alertMsg(errorMsg))
        .finally(() => {
          this.sendingKakao = false
        })
    },
    clearVariables () {
      this.kakaoVariables.forEach(variable => {
        variable.value = ''
      })
      document.querySelectorAll(`input.kakao-variable-input`).forEach(inputTag => {
        inputTag.value = ''
      })
    }
  }
}
</script>

<style lang="scss">
  .instantMsgTemplate {
    .msgTemplate {
      padding-bottom:10px;
      .kakakoTemplate {
        .template_body {
          height: 215px;
        }
      }
    }
    .msgTypeBox {
      .btn {
        position: relative;
        .tooltip {
          position: absolute;
          top:51px;
          right:5px;
          .UXicon-info_outlined {
            font-size:28px;
          }
        }
        .msgCount {
          padding-bottom: 10px;
          font-size: 12px;
          line-height: 16px;
          font-weight: bold;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/fragments/ticket_instant_message.vue